import { computed, ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';
/**
 * Measures the checkbox column's real rendered width (not hardcoded) so the
 * expand column's sticky offset always matches it, instead of two
 * independently guessed pixel values drifting apart between header and body.
 * The header's checkbox <th> is rendered by EnDatagridHeaderList's own column
 * loop (the #prepend slot on EnDataGrid is unused by it), so it's queried by
 * class rather than a template ref.
 */
export function useStickyCheckboxWidth(tableWrapper) {
    const checkboxHeaderCellEl = computed(() => tableWrapper.value?.querySelector('.select-all-header') ?? null);
    const stickyCheckboxWidth = ref(0);
    useResizeObserver(checkboxHeaderCellEl, () => {
        stickyCheckboxWidth.value = checkboxHeaderCellEl.value?.getBoundingClientRect().width ?? 0;
    });
    return { stickyCheckboxWidth };
}
